import { render, staticRenderFns } from "./CreateRtoTrainer.vue?vue&type=template&id=1b6130c7&"
import script from "./CreateRtoTrainer.vue?vue&type=script&lang=js&"
export * from "./CreateRtoTrainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports